import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DateFormatConstants, isNullOrUndefined, TimeZoneUtil } from '@uzurv/core';

export enum PersonSuspensionStatus {
  EFFECTIVE = 'EFFECTIVE',
  EFFECTIVE_ON = 'EFFECTIVE_ON',
  EFFECTIVE_PERMANENTLY = 'EFFECTIVE_PERMANENTLY',
  REMOVED = 'REMOVED',
  EXPIRED = 'EXPIRED'
}

@Component({
  selector: 'app-person-suspension-status-chip',
  templateUrl: './person-suspension-status-chip.component.html',
  styleUrls: ['./person-suspension-status-chip.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class PersonSuspensionStatusChipComponent {
  @Input() status: PersonSuspensionStatus;
  @Input() effectiveAt: Date;

  PersonSuspensionStatus = PersonSuspensionStatus;

  getStatusText(): string {
    if (isNullOrUndefined(this.status)) {
      return '';
    }

    switch (this.status) {
      case PersonSuspensionStatus.EFFECTIVE_PERMANENTLY:
        return 'Effective Permanently';
      case PersonSuspensionStatus.EFFECTIVE:
        return 'Effective';
      case PersonSuspensionStatus.REMOVED:
        return 'Removed';
      case PersonSuspensionStatus.EXPIRED:
        return 'Expired';
      case PersonSuspensionStatus.EFFECTIVE_ON:
        if (this.effectiveAt) {
          const formattedDate = TimeZoneUtil.formatLocalTimeZoneDate(this.effectiveAt, DateFormatConstants.M_D_YY_SLASH);
          return `Effective on ${formattedDate}`;
        }
        return 'Effective on';
      default:
        return '';
    }
  }

  getStatusClass(): string {
    if (isNullOrUndefined(this.status)) {
      return '';
    }

    switch (this.status) {
      case PersonSuspensionStatus.EFFECTIVE_PERMANENTLY:
        return 'status-permanent';
      case PersonSuspensionStatus.EFFECTIVE:
        return 'status-effective';
      case PersonSuspensionStatus.REMOVED:
        return 'status-removed';
      case PersonSuspensionStatus.EXPIRED:
        return 'status-expired';
      case PersonSuspensionStatus.EFFECTIVE_ON:
        return 'status-effective-on';
      default:
        return '';
    }
  }
}
